import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_MANAJEMEN,
  GET_KATEGORI_MANAJEMEN,
  SET_LOADING_DATA_MANAJEMEN,
  SET_LOADING_KATEGORI_MANAJEMEN,
  SET_PAGINATION_DATA_MANAJEMEN,
  SET_PAGINATION_KATEGORI_MANAJEMEN,
} from '../constant.js';

export const getKategoriManajemen = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_KATEGORI_MANAJEMEN,
      payload: true,
    });
    API.get(
      `admin/about/management/cat?${new URLSearchParams(params).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_KATEGORI_MANAJEMEN,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_MANAJEMEN,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_KATEGORI_MANAJEMEN,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_MANAJEMEN,
          payload: 0,
        });
      });
  };
};

export const addKategoriManajemen = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/management/cat/add", params);
};

export const getDetailKategoriManajemen = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/management/cat/${code}`);
};

export const updKategoriManajemen = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/management/cat/edit", params);
};

export const delKategoriManajemen = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/about/management/cat/delete/" + code);
};

export const getDataManajemen = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
   
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_MANAJEMEN,
      payload: true,
    });
    API.get(`admin/about/management?${new URLSearchParams(params).toString()}`)
      .then((res) => {
          console.log(res.data.data.data); 
        dispatch({
          type: GET_DATA_MANAJEMEN,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_MANAJEMEN,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_MANAJEMEN,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_MANAJEMEN,
          payload: 0,
        });
      });
  };
};

export const addDataManajemen = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/management/add", params);
};

export const getDetailDataManajemen = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/management/${code}`);
};

export const updDataManajemen = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/management/edit", params);
};

export const delDataManajemen = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/about/management/delete/" + code);
};
